<template>
  <div id="app">
    <NnnHeader />
    <router-view/>
    <NnnFooter />
  </div>
</template>

<script setup lang="ts">
import NnnHeader from '@/components/NnnHeader.vue';
import NnnFooter from '@/components/NnnFooter.vue';
</script>

<style lang="scss">
@use "@/variables.scss" as *;

@font-face {
  font-family: "Muli";
  src: url("@/assets/font/Muli-Regular.ttf") format("truetype");
  font-display: swap;
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "VAGround";
  src: url("@/assets/font/VarelaRound-Regular.ttf") format("truetype");
  font-display: swap;
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'Muli', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  padding-bottom: 30px;
  font-size: 0.9rem;
}

h1, h2, h3, h4 {
  font-family: 'VAGround', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  margin: 10px auto;
  text-align: left;
}

#app {
  font-family: 'Muli', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.page-container {
  height:100%;
  margin: 10px 30px;
}

// Bootstrap fixes
.page-container a:not(.btn) {
  color: $linkColour;
}

.page-container a:not(.btn):hover {
  color: $linkColourHover;
}

.page-container a.btn {
  color: $linkColourInv;
}

.page-container a.btn:hover {
  color: $linkColourHoverInv;
}

button.btn-primary, button.btn-primary:disabled  {
  background-color: $bgColour;
  border-color: $bgColour;
}

button.btn-primary:hover {
  background-color: $linkColour;
  border-color: $linkColour;
}

button.btn-info {
  background-color: $bgColour;
  border-color: $bgColour;
}

// removes glow around buttons but preserves accessibility
button:focus, .btn:focus {
  box-shadow: none !important;
}

button:active:not(.btn-outline-primary):not(.btn-outline-secondary):not(.btn-outline-success):not(.btn-outline-danger):not(.btn-outline-warning):not(.btn-outline-info):not(.btn-outline-light):not(.btn-outline-dark), 
.btn:active:not(.btn-outline-primary):not(.btn-outline-secondary):not(.btn-outline-success):not(.btn-outline-danger):not(.btn-outline-warning):not(.btn-outline-info):not(.btn-outline-light):not(.btn-outline-dark) {
  box-shadow: none !important;
}

// Keep focus indicators for accessibility
:focus-visible {
  outline: 2px solid $linkColour;
  outline-offset: 2px;
}

.form-control:focus {
  box-shadow: none !important;
  border: 1px solid $bgColour !important;
}

.cp {
  cursor: pointer;
}

.form-page {
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
}

label {
  font-weight: bold;
  color: $bgColour;
}

.tip {
  font-size: 0.7rem;
  font-style: italic;
  color: #999;
}

.error {
  color: red;
  font-weight: bold;
}

.form-container {
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
}


</style>
